import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IFontProps {
    fontFamily: string;
    isSelected: boolean;
}

export const Root = styled.div`
    padding: 0px 0px 0px 0px;
    height: 100%;
    overflow-y: auto; 
`;

export const TopBottomSpace = styled.div`
    padding: 15px 0px 0px 0px;
`;

export const OEMFontsContainer = styled.div`
`;

export const CommonFontsContainer = styled.div`
`;

export const Title = styled.div`
    font-family: Roboto;
    font-size: 13px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #122442;
    padding: 8px 0px 8px 15px;
`;

export const FontItem = styled.div`
    font-family: ${(props: IFontProps) => props.fontFamily };
    font-size: 13px;
    text-align: left;
    color: #122442;
    padding: 8px 15px 8px 25px;
    cursor: pointer;
    &:hover {
        background: rgba(18, 36, 66, 0.05);
    }
    background: ${(props: IFontProps) => props.isSelected ? "rgba(18, 36, 66, 0.05)" : "#FFFFFF" };
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const Separator = styled.div`
    width: 100%;
    height: 1px;
    margin: 20px 0px 20px 0px;
    background-color: #c4c4c4;
`;

export const Message = styled.span`
    font-family: Roboto;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #122442;
    margin: 0px 0px 0px 20px;
`;
